import { Injectable } from '@angular/core';
import {
  DataPageDefault,
  DataQueryParamPage,
  DataWorkshopEntity,
  DataQueryParamWorkshopName,
  DataQueryParamFrom,
  DataQueryParamTo,
  DataStartedAt,
} from '@edgvr-front/data/domain';
import {
  createEffect,
  Actions,
  ofType,
  EffectNotification,
  concatLatestFrom,
} from '@ngrx/effects';
import { getSelectors } from '@ngrx/router-store';
import { Observable, throwError } from 'rxjs';
import {
  catchError,
  exhaustMap,
  mergeMap,
  switchMap,
  takeUntil,
} from 'rxjs/operators';
import { DataWorkshopWorkshopsListPageActions } from '../actions';
import { DataService } from '../services';
import { Store } from '@ngrx/store';
import { DataWorkshopsListRequestDTO } from '../dto';

const { selectRouteParams, selectQueryParams } = getSelectors();

@Injectable()
export class DataWorkshopWorkshopsListPageEffects {
  init$ = createEffect(() =>
    this.store.select(selectRouteParams).pipe(
      concatLatestFrom(() => [this.store.select(selectQueryParams)]),
      mergeMap(([_, queryParams]) => [
        DataWorkshopWorkshopsListPageActions.dataWorkshopsList({
          page: Number(queryParams[DataQueryParamPage]) || DataPageDefault,
          workshopName: queryParams[DataQueryParamWorkshopName],
          from:
            (Number(queryParams[DataQueryParamFrom]) as DataStartedAt) ||
            undefined,
          to:
            (Number(queryParams[DataQueryParamTo]) as DataStartedAt) ||
            undefined,
        }),
      ])
    )
  );

  dataWorkshopsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DataWorkshopWorkshopsListPageActions.dataWorkshopsList),
      switchMap(({ page, workshopName, from, to }) =>
        this.dataService
          .dataWorkshopsList(
            new DataWorkshopsListRequestDTO({
              page,
              workshopName,
              from,
              to,
            })
          )
          .pipe(
            mergeMap((_) => [
              DataWorkshopWorkshopsListPageActions.dataWorkshopsListSuccess({
                dataWorkshops: _.data.dataWorkshops.map((_) =>
                  DataWorkshopEntity.factory(_)
                ),
                count: _.data.count,
                page,
              }),
            ]),
            catchError((_) => {
              this.store.dispatch(
                DataWorkshopWorkshopsListPageActions.dataWorkshopsListFailure()
              );

              return throwError(() => _);
            })
          )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly dataService: DataService
  ) {}

  ngrxOnRunEffects(resolvedEffects$: Observable<EffectNotification>) {
    return this.actions$.pipe(
      ofType(DataWorkshopWorkshopsListPageActions.init),
      exhaustMap(() =>
        resolvedEffects$.pipe(
          takeUntil(
            this.actions$.pipe(
              ofType(DataWorkshopWorkshopsListPageActions.destroy)
            )
          )
        )
      )
    );
  }
}
